export default __webpack_public_path__ + "media/images/services-09-370x250-9e089f414fa71a9fe59fa21ab525e28c.jpg";